module.exports = __webpack_public_path__ + "static/img/training_system_s5_max3.c8bc6d84.png";